import React, { useEffect, useState } from "react";
import { Grid, InputAdornment, TextField } from "@mui/material";
import { get } from "lodash";
import { connect, useSelector } from "react-redux";
import { ConfigPropExtenderHoc } from "../../../../../common/StaticConfigProvider";
import OptionalToolTip from "../../../../../common/toolTip/OptionalToolTip";
import SelectDropDown from "../../../../../common/formElements/SelectDropDown";

interface ConfigurationProps {
    labelTooltip: string;
    isUpdateAllowed?: boolean;
    checkedPreAuth?: boolean;
    PreAuth?: { ExpiryDays?: number; VariancePercentage?: number }
    onPreAuthValueChanged?: (val: { ExpiryDays?: number; VariancePercentage?: number }) => void;
    shouldHideField: (fieldName: string) => boolean;
}

interface ConfigurationHocProps {
    labelTooltip?: string;
    toolTips?: { terminals?: { options?: Record<string, string> } };
    isUpdateAllowed?: boolean;
    checkedPreAuth?: boolean;
    PreAuth?: { ExpiryDays?: number; VariancePercentage?: number }
    onPreAuthValueChanged?: (val: { ExpiryDays?: number; VariancePercentage?: number }) => void;
    shouldHideField: (fieldName: string) => boolean;
}

const ConfigurationPreAuth = (props: ConfigurationHocProps) => {
    const { isUpdateAllowed, onPreAuthValueChanged, checkedPreAuth, shouldHideField } = props;
    const [ExpiryDays, setExpiryDays] = useState(props.PreAuth?.ExpiryDays ?? 28);
    const [VariancePercentage, setVariancePercentage] = useState(props.PreAuth?.VariancePercentage ?? 15);
    const variances = [{ 0: "0" }, { 10: "10" }, { 15: "15" }, { 20: "20" }, { 25: "25" }, { 999999: "999999" }];
    const [disableField, setDisableField] = useState(!isUpdateAllowed || !checkedPreAuth);
    useEffect(() => {
        if (onPreAuthValueChanged) {
            onPreAuthValueChanged({ ExpiryDays, VariancePercentage });
        }
    }, [ExpiryDays, VariancePercentage])
    useEffect(() => {
        setDisableField(!isUpdateAllowed || !checkedPreAuth);
    }, [isUpdateAllowed, checkedPreAuth])
    return (
        <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
                <OptionalToolTip
                    tooltip={get(
                        props,
                        `toolTips.terminals.options.configuration.PreAuth`
                    )}
                >
                    <SelectDropDown
                        fieldname="attributes.PreAuth.VariancePercentage"
                        label="Pre Auth Variance default 15(%)"
                        options={variances}
                        disabled={disableField}
                        value={[0, 10, 15, 20, 25, 999999].includes(VariancePercentage) ? VariancePercentage : 15}
                        onChange={(event) => {
                            setVariancePercentage(parseInt(event.target.value, 10));
                        }}
                    />
                </OptionalToolTip>
            </Grid>
            <Grid item xs={12} md={6}>
                <OptionalToolTip
                    tooltip={get(
                        props,
                        `toolTips.terminals.options.configuration.PreAuth`
                    )}
                >
                    <TextField
                        type="number"
                        value={ExpiryDays}
                        name="ExpiryDays"
                        label="Pre Auth Expirydays default (28)"
                        disabled={disableField}
                        variant="outlined"
                        fullWidth
                        onInput={(e) => {
                            const target = e.target as HTMLInputElement;
                            target.value = target.value.replace(/[^0-9]/g, "");
                            if (target.value.length > 3) {
                                target.value = target.value.substring(0, 3);
                            }

                        }}
                        onChange={(event) => {
                            setExpiryDays(parseInt(event.target.value, 10));
                        }}
                    />
                </OptionalToolTip>
            </Grid>
        </Grid>
    );
};

const ConnectedConfigurationStartup = connect(
    null,
    null,
    (_stateProps, _dispatchProps, ownProps: ConfigurationHocProps) => {
        return {
            ...ownProps,
            shouldHideField: ownProps.shouldHideField,
        };
    }
)(ConfigurationPreAuth);

const ConnectedConfigurationPreAuthHoc = (props: ConfigurationProps) => (
    // @ts-ignore
    <ConfigPropExtenderHoc propName="toolTips">
        <ConnectedConfigurationStartup {...props} />
    </ConfigPropExtenderHoc>
);

export default ConnectedConfigurationPreAuthHoc;
